(function () {
    angular
        .module('smartertoolsApp')
        .controller('cartInstallationOfferController', ['$scope', '$location', '$http', cartInstallationOfferController]);

    function cartInstallationOfferController($scope, $location, $http) {
        const vm = this;
        vm.productTotal = productTotal;
        vm.getTitle = getTitle;
        vm.productQueryOptions = productQueryOptions;
        vm.addProductToCart = addProductToCart;
        vm.removeItem = removeItem;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.product = {
                selections: JSON.parse(SessionStorageWithFallback.get('smartertoolsPreCart')),
                state: null,
                hasEnterprise: false,
                wantsInstallation: true
            };
            vm.cartGuid = SessionStorageWithFallback.get('smartertoolsCartGuid');

            const needRemoval = JSON.parse(SessionStorageWithFallback.get('RemovalItemId'));
            if (needRemoval) {
                vm.removeItem(needRemoval);
            }
            SessionStorageWithFallback.set('RemovalItemId', '');
            vm.product.hasEnterprise = vm.product.selections.Edition !== 'Professional';
            vm.productQueryOptions();
            getBack();
        }

        function removeItem(item) {
            $http.post(`${apiRootUrl}v1/cart/remove-purchase-item`, JSON.stringify({
                CartId: vm.cartGuid,
                CartItemId: item
            }))
                .then(() => {
                }, () => {
                });
        }

        function productQueryOptions() {
            $http.post(`${apiRootUrl}v1/cart/new-purchase-options`, JSON.stringify(vm.product.selections))
                .then(response => {
                    let data = response.data;
                    vm.product.state = data;
                    vm.product.hasEnterprise = vm.product.selections.Edition !== 'Professional';
                    vm.product.wantsInstallation = true;
                    for (let i = 0; i < data.Sections.length; i++) {
                        data.Sections[i].DefaultTitle = data.Sections[i].Title;
                    }
                    $scope.$applyAsync();
                }, () => {
                });
        }

        function addProductToCart() {
            let addInstallation = vm.product.wantsInstallation;
            vm.product.selections.CartId = vm.cartGuid;
            let data = vm.product.selections;
            data.AlaCarteItems = vm.product.selections.AlaCarteItems;

            if (addInstallation) {
                data.FreeInstallationHelp = true;
            }

            $http.post(`${apiRootUrl}v1/cart/new-purchase-add`, JSON.stringify(data))
                .then(response => {
                    let data2 = response.data;
                    vm.cartGuid = data2.CartId;
                    SessionStorageWithFallback.set('smartertoolsCartGuid', vm.cartGuid);
                    $location.path('/');
                    $scope.$applyAsync();
                }, () => {
                });
        }

        function productTotal() {
            return (vm.product.state ? vm.product.state.Total + 0 : 0);
        }

        function getTitle() {
            let title = 'Congratulations on choosing ';
            if (vm.product.state)
                title += vm.product.state.Title;
            if (vm.product.selections.Edition) {
                title += vm.product.selections.Edition ? ' ' + vm.product.selections.Edition : '';
            }
            if (vm.product.state) {
                if (vm.product.state.Sections[1]) {
                    title += vm.product.state.Sections[1].Selected ? ' - ' + vm.product.state.Sections[1].DefaultTitle : '';
                }
            }
            title += '!';
            return title;
        }

        function getBack() {
            vm.product.back = {display: 'Add Product', url: '/purchase/#/add/' + vm.product.selections.Product};
        }
    }
})();